import React from 'react';
import { NewProjectUserFormState } from 'src/app/admin/views/user-management/state/userManagementSlice';
import { Role } from 'src/shared/types';
import CustomerRoleCheckboxes from 'src/app/admin/views/user-management/components/assign-admin-roles/CustomerRoleCheckboxes';
import styles from '../EditProjectUser.module.scss';

type CustomerRolesSectionProps = {
    roles: Role[];
    defaultRoles?: Role[] | null;
    isInternalUser: boolean;
    /** Whether the current viewer (super admin / onboarding manager) may manage roles at all. */
    canManageRoles: boolean;
    onChange: (fragment: Partial<NewProjectUserFormState['formState']>) => void;
};

/**
 * Shared "Customer Roles" section for EditProjectUser and ReassignUserToOrganisation -- heading +
 * permission gate + CustomerRoleCheckboxes. Renamed from "Admin roles": on these edit-side screens the
 * section can only ever offer CUSTOMER_ADMIN/CUSTOMER_VIEWER (Organisational Viewer isn't offered here
 * -- adminUpdateUser has no groups field, see the assign-admin-roles components), so there's nothing
 * left to show an internal user at all.
 */
const CustomerRolesSection = (props: CustomerRolesSectionProps) => {
    const { roles, defaultRoles, isInternalUser, canManageRoles, onChange } = props;

    if (!canManageRoles || isInternalUser) {
        return null;
    }

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeading}>Customer Roles</div>
            <CustomerRoleCheckboxes onChange={onChange} roles={roles} defaultRoles={defaultRoles} isInternalUser={isInternalUser} />
        </div>
    );
};

export default CustomerRolesSection;
